import { PlanSeq } from '@mobi/api-types'
import type { Ticket } from '@core/Areas/Account/Pages/Activity/types'
import type { BetLoopShareTicket } from '@core/Areas/BetLoop/types'

export function isDerivativeBetTypeTicket(ticket: Ticket | BetLoopShareTicket) {
  if (ticket.planSeq !== PlanSeq.FOBRacing) return false
  if (ticket.legs.length > 1) return false
  if (!ticket.legs[0].betType) return false

  const cleanBetType = ticket.legs[0].betType.toLowerCase()
  return !(cleanBetType.includes('win') || cleanBetType.includes('place'))
}
